import React from 'react'
import styled from 'styled-components'
import Card from 'pages/HehmDevice/HehmDashboard/Card'

export const LabelAndValue = ({ label, value, isRequired = false }: { label: string, value: string | JSX.Element, isRequired?: boolean }) => {
  return (
    <S.LabelAndValueContainer>
      <Card.ItemLabel>{label}{isRequired && <strong> *</strong>}</Card.ItemLabel>
      <Card.ItemValue>{value}</Card.ItemValue>
    </S.LabelAndValueContainer>
  )
}

const S = {
  LabelAndValueContainer: styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
  `
}

export default LabelAndValue
